import {
  SKELETON_GAP_XS,
  SKELETON_HEIGHT_XS,
} from '@/components/SkeletonLoading/constants';
import { Skeleton } from 'antd';
import classnames from 'classnames/bind';
import { FC, memo, useMemo } from 'react';
import styles from './SkeletonLoading.module.scss';

const cx = classnames.bind(styles);

export const LoadingSkeleton: FC<{
  height?: number;
  style?: React.CSSProperties;
}> = memo(({ height = SKELETON_HEIGHT_XS, style: _style }) => {
  const style = useMemo(
    () => ({
      height,
      display: 'flex',
      ..._style,
    }),
    [_style, height]
  );
  return <Skeleton.Input active size='small' block style={style} />;
});
LoadingSkeleton.displayName = 'LoadingSkeleton';

export const LoadingSkeletonList: FC<{
  repeatCount: number;
  loadingHeight?: number;
  gap?: number;
  style?: React.CSSProperties;
}> = memo(
  ({
    repeatCount,
    loadingHeight = SKELETON_HEIGHT_XS,
    gap = SKELETON_GAP_XS,
    style: _style,
  }) => {
    const style = {
      height: loadingHeight,
      marginBottom: gap,
      ..._style,
    };
    return (
      <div className={cx(styles['skeleton-loading-list-container'])}>
        {Array.from({ length: repeatCount }).map((_, index) => (
          <LoadingSkeleton key={index} style={style} />
        ))}
      </div>
    );
  }
);
LoadingSkeletonList.displayName = 'LoadingSkeletonList';
